import { FunctionComponent } from 'preact';

import { lazyWithRetry } from '@shared/utils';

import { ILottieOptions } from './lottieRenderer/LottieRenderer';

export { default as ErrorAnimation } from '@shared/components/common/errorAnimation/ErrorAnimation';
export { default as PhonePeBrand } from '@shared/components/common/phonePeBrand/PhonePeBrand';
export { default as Show } from '@shared/components/common/show/Show';

export const LottieRenderer = lazyWithRetry(
	() =>
		import(
			/* webpackChunkName: "lottie-renderer" */ './lottieRenderer/LottieRenderer.tsx'
		) as unknown as Promise<{ default: FunctionComponent }>,
) as unknown as FunctionComponent<{ options: ILottieOptions }>;
